"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var json_to_graphql_query_1 = require("json-to-graphql-query");
var Logger_1 = require("../util/Logger");
var Params_1 = require("../util/Params");
var QUERY = "__query__";
function __parseField(field, data, callback) {
    if (data === void 0) { data = {}; }
    var _a;
    if (typeof field.includeIf === 'function' && !field.includeIf(data)) {
        return false;
    }
    var o = {};
    if (!!field.aliasFor) {
        o.__aliasFor = field.aliasFor;
    }
    if (!!field.directive) {
        o.__directive = (_a = {}, _a[field.directive] = true, _a);
    }
    if (typeof field.params === 'object' || typeof field.params === 'function') {
        var args = Params_1.getParams(field.params, data);
        if (!!args && Object.keys(args).length > 0) {
            o.__args = args;
            callback(args);
        }
    }
    if (typeof field.entity === 'function') {
        var instance = new field.entity();
        var fields = instance[QUERY] && instance[QUERY].fields || [];
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var subField = fields_1[_i];
            o[subField.name] = __parseField(subField, data, callback);
        }
    }
    return Object.keys(o).length > 0 ? o : true;
}
function __generate(type, data, fields, name) {
    if (type === void 0) { type = "query"; }
    if (data === void 0) { data = {}; }
    if (fields === void 0) { fields = []; }
    var _a;
    var schema = {};
    var variables = {};
    var callback = function (d) {
        Params_1.findVariables(d, function (variable) {
            var variableType = variable.getTypeString();
            if (!!variables[variable.value] && variables[variable.value] !== variableType) {
                Logger_1.default.throw("duplicate.variable");
            }
            variables[variable.value] = variableType;
        });
    };
    for (var _i = 0, fields_2 = fields; _i < fields_2.length; _i++) {
        var field = fields_2[_i];
        schema[field.name] = __parseField(field, data, callback);
    }
    if (Object.keys(variables).length > 0) {
        schema.__variables = variables;
    }
    var str = json_to_graphql_query_1.jsonToGraphQLQuery((_a = {}, _a[type] = schema, _a));
    return !!name ? str.slice(0, type.length) + ' ' + name + str.slice(type.length) : str;
}
var root = function (clazz, data) {
    var instance = new clazz();
    var _a = (instance[QUERY] || {}), _b = _a.fields, fields = _b === void 0 ? [] : _b, _c = _a.operation, operation = _c === void 0 ? {} : _c;
    var _d = operation.type, type = _d === void 0 ? "query" : _d, _e = operation.name, name = _e === void 0 ? clazz.name : _e;
    return __generate(type, data, fields, name);
};
var query = function (entity, data, field, name) {
    return __generate("query", data, [__assign({}, field, { entity: entity })], name);
};
var mutation = function (entity, data, field, name) {
    return __generate("mutation", data, [__assign({}, field, { entity: entity })], name);
};
var subscription = function (entity, data, field, name) {
    return __generate("subscription", data, [__assign({}, field, { entity: entity })], name);
};
exports.default = { root: root, query: query, mutation: mutation, subscription: subscription };
//# sourceMappingURL=generate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/generate/generate.js
// module id = 1452
// module chunks = 0